import { Flex, Skeleton } from 'antd';

const ROW_WIDTHS = ['100%', '60%', '53%', '64%', '58%'];

export const CoveragesSkeleton = () => (
  <Flex vertical style={{ width: '100%', maxWidth: '18em' }}>
    {ROW_WIDTHS.map((width, index) => (
      <Flex key={index} gap={16}>
        <Skeleton.Button
          active
          size='small'
          shape='circle'
          style={{ width: '1em', minWidth: '1em', height: '1em' }}
        />
        <Skeleton
          active
          title={false}
          paragraph={{
            rows: 1,
            width: width,
          }}
        />
      </Flex>
    ))}
  </Flex>
);
